import "./print.css";
import { localizeDateTime } from "../../../../utils";

const TermsAndConditions = (props: any) => {
  const name = props?.printData?.customer_name;
  const termsAndConditions = props?.printData?.brand?.terms_and_conditions;

  return (
    <>
      <div style={{ textAlign: "center" }}>
        <p style={{ marginBottom: "2px" }}>
          <b>Terms and Conditions for Installation of AC Charger</b>
        </p>
      </div>

      <div style={{ fontSize: 10 }} className="term-and-condition-contaienr">
        <p>
          I,{" "}
          <span>
            <u>{name}</u>
          </span>
          acknowledge that I have read and fully understood all the terms and conditions mentioned
          herein and that I hereby agree and accept all the terms laid down herein:
        </p>
        {termsAndConditions ?
          <div dangerouslySetInnerHTML={{ __html: termsAndConditions }} />
          :
          <div>
            <p>
              01. eChargeBays team will ensure installation of electric wiring/cabling work to enable
              EVSE (i.e. AC Charger) installation at customers’ premises. eChargeBays will engage an
              Installation partner for this purpose who will do the survey and installation work once a
              go ahead is received from the concerned
            </p>
            <p>
              02. The customer shall allow eChargeBays and its Installation Partner, access to the
              premises where the charger is to be installed, under full supervision of the customer /
              customer representative
            </p>
            <p>
              03. Customer is requested to comply to instructions / directions given by the eChargeBays
              in respect of the pre installation, use or operation of the Charger and all related
              equipment
            </p>
            <p>
              04. The Customer will ensure that all necessary approvals and permissions required (for ex
              from: RWA, housing society, private builder, local civic authority, DISCOM etc.) to carry
              out the necessary work, as explained by eChargeBays or its installer, are taken by the
              customer eChargeBays or its installer and eChargeBays or its installer has no role to play
              in taking these permissions and will not be responsible for any action arising at a later
              date due to the work being carried out without appropriate, prior permissions. The
              Customer shall indemnify the Installer and/or eChargeBays if any action by the above said
              authorities is taken against them due to non-compliance on the part of the Customer.{" "}
            </p>
            <p>
              05. Any delay on account of approvals mentioned in point 4 will not be the responsibility
              of eChargeBays or its Installer partner
            </p>
            <p>
              06. Customer will be informed in advance about the nature of work required for pre
              installation, which may include, but not limited to breaking/digging of a small area of
              the floor for the purpose of earthing and for creating foundation for Steel Stand in case
              the charger is Stand mounted. Customer approves this work without any objection. Once this
              process is concluded then the customer will not make any claim for damages/changes arising
              out of this work. Customer is free to be present at the installation site at all times to
              ensure that the work is done as per the details captured in the survey form{" "}
            </p>
            <p>
              07. Customer shall fully indemnify and hold eChargeBays & its Installation Partner
              harmless at all times against all actions, claims, liability, losses, damages and
              proceedings (including legal costs & proceedings whatsoever), which may be arising out of
              or by reason of any deficiency, breakdown or failure of any equipment. eChargeBays will
              make sure that any defect in the work is promptly rectified once it is brought to the
              notice of eChargeBays as per the agreed terms
            </p>
            <p>
              08. Customer hereby agrees and authorizes eChargeBays to store customer data for the
              purpose of contacting customer at a later date for upgradation of firmware in the
              equipment. Customer also agrees that the charging data can be used by eChargeBays for
              studying user EV charging data, which will help in future product upgradation. eChargeBays
              will not divulge the individual customer details under any circumstances to any outside
              party
            </p>
            <p>
              09. Apart from pre-installation work explained in above points eChargeBays and its
              Installation partner will provide guidance related to enhancing power load for the purpose
              of installing the AC Charger. The support provided will be only assistive in nature. All
              permissions and approvals related to this work (from concerned authorities/ DISCOM/RWA
              etc.) are not in the scope of work of either eChargeBays or its installation partner
            </p>
            <p>
              10. All charges related to additional electricity meter and load enhancement are to be
              borne by the customer on actual basis. eChargeBays team will only have assistive role by
              providing the necessary guidance. No visits to concerned office that provides the load
              enhancement will be carried out by eChargeBays team or its representative
            </p>
            <p>
              11. During the installation work at customer’s premises, it is advisable that one
              representative of the customer be present at the site
            </p>
            <p>
              12. The installation work done by eChargeBays team will stand warranty for 6 months from
              the date of completion of the setup irrespective of whenever the actual charger is
              commissioned on site. During this 6-month period, if there is any shortcoming that arises
              due to the quality of the work or material, then the same will be rectified free of charge
              by eChargeBays/ its Installer team
            </p>
            <p>
              13. Installation done by eChargeBays/ its Installer team should not be tampered with or
              changed. If installation done by eChargeBays is by any means modified by any local
              electrician or any other 3rd party then warranty on the installation will stand withdrawn
              and eChargeBays / the Installer shall not be held liable for the same.
            </p>
            <p>
              14. The wiring infra provided by eChargeBays is in line with the technical requirements of
              the EV defined by the OEM concerned. For charging any other EV, customer has to verify
              technical feasibility from concerned authorities
            </p>
            <p>
              15. Wiring /Cabling connection will be connected to only the main electricity supply.
              Under no circumstances will connections be made with inverter or generator as a charging
              backup
            </p>
            <p>16. Faults related to AC Charger are to be addressed to EVSE supplier</p>
            <p>
              17. A survey will be carried out by eChargeBays team at the customer location in order to
              assess the complete quantum of work involved. Basis this, the time and cost estimation
              will be provided to the customer for making the site EVSE ready (a separate Performa
              Invoice (PI) will be sent to the customer indicating the time & cost). It will not include
              the time/cost for getting power load enhancement from the concerned authorities. In case
              the customer agrees to the time /cost estimate, the customer will have to sign the PI and
              send back to eChargeBays after which the work will commence
            </p>
            <p>
              18. Basis PI acceptance by customer, upon completion of the work, the customer will pay
              eChargeBays the amount agreed in the PI as per payment details mentioned in PI. No money
              in any form will be paid to the Installer or any person who is not authorized by
              eChargeBays. There will be no cash transaction. In case there is any change in the routing
              of the wire from what was indicated during the survey period or in case there is any other
              change due to any reasons that warrants more / less quantity of material etc. then a
              revised estimate will be given to the customer for approval and work will be completed
              post approval of that estimate. Once the charger is installed and the payment is released
              by the customer basis the PI, the car will be delivered by the dealership{" "}
            </p>
            <p>
              19. Once commissioned, the Charger should not be dismounted from the planned location
              where all pre-installation and installation connections have been made for the charger.
              Any such activity will nullify the warranty and can pose danger to the person charging the
              car or to any other person passing near the charger. eChargeBays will not be responsible
              for any consequences arising out of this
            </p>
            <p>
              20. The connections and the EV charger should not be exposed to direct water spray under
              any circumstances. Water seeping through to the connections can pose danger to the charger
              users
            </p>
            <p>21. Keep children away from the site where EV charger connections are installed</p>
            <p>
              22. Customer has to ensure that the charger (or related connections) is never cleaned with
              aggressive solvents and cleaning agents, abrasive materials, spray water (garden hose,
              high-pressure cleaner, etc.) or excessive pressure
            </p>
            <p>
              23. No unauthorized modifications should be made to the charging station or its
              installation base{" "}
            </p>
            <p>
              24. The Customer cannot make eChargeBays/ Installer liable for any of the above conditions
              not adhered to by the Customer as mentioned herein. The Customer further agrees to
              indemnify eChargeBays and/or the Installer in case the Customer fails to perform any of
              it's duties and obligations as mentioned herein
            </p>
            <p>
              25. It is understood that civil work as explained on page 2 & 4 is not in SOW for
              eChargeBays or its installer partner
            </p>
          </div>
        }
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          height: "250px"
        }}
      >
        <div style={{ border: "1px solid black", width: "45%", height: "160px", padding: "8px" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            {props?.printData?.agent_sign ? (
              <>
                <p>Survey done by:</p>
                <img src={props?.printData?.agent_sign} width={200} height={80} />
                <p>Signature and co name of the surveyor</p>
              </>
            ) : (
              <>
                <p>Signature:</p>
                <p></p>
                <p></p>
                <p></p>
                <p>Signature and co name of the surveyor</p>
              </>
            )}
          </div>
        </div>
        <div style={{ border: "1px solid black", width: "45%", height: "160px", padding: "8px" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            {props?.printData?.customer_sign ? (
              <>
                <p></p>
                <img src={props?.printData?.customer_sign} width={200} height={90} />
                <p>
                  Signature of Customer {localizeDateTime(props?.printData?.customer_signed_at)}
                </p>
              </>
            ) : (
              <>
                <p></p>
                <p></p>
                <p></p>
                <p></p>
                <p>Signature of Customer [Date]</p>
              </>
            )}
          </div>
        </div>
      </div>
      <div
        style={{
          border: "1px solid Grey",
          textAlign: "center",
          borderRadius: 4
        }}
      >
        <p style={{ fontSize: 10, margin: 2 }}>
          <b>Customer is requested to read the contents of this report</b>
        </p>

        <p style={{ fontSize: 10, margin: 2 }}>
          eChargeBays; L29 - L34, First Floor, Block L Connaught Place Delhi-110001 |
          contact@echargebays.com
        </p>
        <p style={{ fontSize: 10, fontWeight: 500, margin: 2 }}>
          Copyright (C) {new Date().getFullYear()} Echargebays Emobility Pvt Ltd. All rights
          reserved.
        </p>
      </div>
    </>
  );
};

export default TermsAndConditions;
